import os from 'os';

const config = {
  projectId: 9,
  apiUrl: 'https://api.eaglecrest.groupcore.ca',
  apiToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwcm9qZWN0Ijo5LCJzY29wZSI6InByb2plY3QiLCJ1c2VydHlwZSI6InVzZXJzIiwiaWF0IjoxNjM5NTc5MjcyfQ.OPPVgqRKqEpVlY2FdGcxDDksx-LyaVSL9a0P2k6i2ng',
};

export default config;
